@import 'src/styles/common/colors.scss';
.radioColumn{
	flex-direction:column;
}
.radioButton {
	margin-right: 5px;
	padding-left: 28px;
	input[type="radio"] {
		margin: 0;
		padding: 0;
		opacity: 0;
		height: 14px;
		width: 15px;
		display: none;
	}
	input[type="radio"] + label > span {
		display: inline-block;
		height: 14px;
		width: 15px;
		margin-right: 4px;
		margin-top: -2px;
		vertical-align: middle;
		border: 1px solid $black;
		background: linear-gradient(to bottom, $radio-button-background-1 0%, $radio-button-background-2 100%);
		cursor: pointer;
	}

	input[type="radio"]:checked + label > span:before {		
		color: $black;
		top: -3.2px;
		left: -3px;
		position: relative;
	}
	input[type="radio"] + label {
		cursor: default;
		display: inline-block;
		margin: 0 0 0 -19px;
	}

	input[type="radio"]:checked + label > span:before {
		text-shadow: none;
		content: "\e60d";
		font-size: 1.125rem;
		margin-left:0;
	}

	input[type="radio"] + label {
		margin: 0 0 0 -17px;
		text-align: initial;
		line-height: 1.25rem;
	}

	input[type="radio"] + label > span {
		width: 14px;
		border-radius: 7px;
	}

	input[type="radio"]:checked + label > span {
		font-family: "icomoon";
		background: linear-gradient(to bottom, $radio-button-background-3 0%, $radio-button-background-3 100%);
	}
	input[type="radio"][disabled] {
		cursor: default;

		& + label {
			color: $label;

			& > span {
				background: linear-gradient(to bottom, $radio-button-background-5 0%, $background-variant-1 100%);

				&:before {
					color: $radio-button-background-6;
				}
			}
		}
	}

	input[type="radio"] {
		&:hover:not(:checked):not([disabled]) + label > span {
			background: linear-gradient(to bottom, $radio-button-background-7 0%, $radio-button-background-8 100%);
		}
	}

	input[type="radio"] {
		&:active:not(:checked):not([disabled]) + label > span {
			background: linear-gradient(to bottom, $radio-button-background-2 0%, $radio-button-background-9 100%);
		}
	}
	
	
}
.radioIconSize {
	font-size: 20px;
	margin-left: 6px;
	color : $gray-variant-1;
}
.highlightWrapper{
	display: inline;
}

